module.exports = __webpack_public_path__ + "img/6.c3db982c.jpg";